module.exports = __webpack_public_path__ + "4c7264cb457f89d2bff867c3c07ba2bc.png";